// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__1qX6E","meals-appear":"AvailableMeals_meals-appear__2peFo","loading":"AvailableMeals_loading__kbsIo","MealsError":"AvailableMeals_MealsError__BEhzR"};